import { toRelativeUrl } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import { Loading as LoadingPage } from '@pages/Loading';
import { userAtom } from '@states/Atoms';
import React, { useEffect } from 'react';
// import React from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilState } from 'recoil';

const history: string[] = [];

const RequiredAuth = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const [, setUserInfoState]: any = useRecoilState(userAtom.infomationState);
    const [, setUserIdTokenState]: any = useRecoilState(userAtom.userIdTokenState);

    useEffect(() => {
        oktaAuth.getUser().then((info) => {
            setUserInfoState(info);
        }).catch((err) => {
            setUserInfoState({});
        });

        // IDトークンの取得
        const idToken = oktaAuth.getIdToken();

        // IDトークンヘッダ・ペイロードをJSON形式に変換
        const idTokenPayload = idToken?.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const idTokenPayloadJson = JSON.parse(decodeURIComponent(escape(window.atob(idTokenPayload || ""))));

        // IDトークンの保持（ユーザー情報ページにおけるグループロールの識別に使用）
        setUserIdTokenState(idTokenPayloadJson);

    }, [oktaAuth, setUserInfoState, setUserIdTokenState]);

    if (!authState || !authState?.isAuthenticated || history.pop() === 'loading') {
        const originalUri = toRelativeUrl(window.location.href, window.location.origin);
        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();
        history.push('loading');
        return (
            <LoadingPage />
        );
    }
    history.push('outlet');

    return (<Outlet />);
}

export default RequiredAuth;